import LoginView from './views/LoginView.vue'
import NotFound from './views/404View.vue'
import HomeView from './views/HomeView.vue'
import Navigation from './views/Navigation.vue'
import welcomeView from './views/welcomeView.vue'
import AppLogin from './views/AppLogin.vue'
import Agent from './views/app/agent.vue'
import Copy from './views/app/copy.vue'
import AppUserInfo from './views/app/appUserInfo.vue'
import Fileh5 from './views/fileh5.vue'
import H5Upload from './views/H5Upload.vue'
import JournalFileh5 from './views/JournalFileh5.vue'
import CommonUploadH5 from './views/CommonUploadH5.vue'
import syntheticDataH5 from '@/views/operationDataH5/syntheticDataH5.vue'



// const StatisticsView = ()=>import("@/views/project/statistics")


let routes = [
    {
        path: '/login',
        component: LoginView,
        name: '',
        leaf:false,
        hidden: true
    },
    {
        path: '/appLogin',
        component: AppLogin,
        name: '',
        leaf:false,
        hidden: true,
    },
    {
        path: '/appLogin/agent',
        component: Agent,
        name: '',
        leaf:false,
        hidden: true
    },
    {
        path: '/appLogin/copy',
        component: Copy,
        name: '',
        leaf:false,
        hidden: true
    },
    {
        path: '/appLogin/appUserInfo',
        component: AppUserInfo,
        name: '',
        leaf:false,
        hidden: true
    },
    {
        path: '/fileh5',
        component: Fileh5,
        name: '',
        leaf:false,
        hidden: true
    },
    {
        path: '/h5upload',
        component: H5Upload,
        name: '',
        leaf:false,
        hidden: true
    },
    {
        path: '/JournalFileh5',
        component: JournalFileh5,
        name: '',
        leaf:false,
        hidden: true
    },
    {
        path: '/CommonUploadH5',
        component: CommonUploadH5,
        name: '',
        leaf:false,
        hidden: true
    },
    {
        path: '/404',
        component: NotFound,
        name: '',
        leaf:false,
        hidden: true
    },
    {
        path: '*',
        hidden: true,
        leaf:false,
        redirect: { path: '/404' }
    }, 
    {
        path: '/operationDataH5',
        component: syntheticDataH5,
        name: '',
        leaf:false,
        hidden: true
    },
    {
        path: '/pdfViewH5',
        component: () => import('@/views/pdfView'),
        name: 'pdfViewH5',
        leaf:false,
        hidden: true
    },
    {
        path: '/businessInfoH5',
        component: () => import('@/views/businessInfo'),
        name: 'businessInfo',
        leaf:false,
        hidden: true
    },
    {
        path: '/datav/index',
        component: () => import('@/views/datav/index'),
        leaf: false,
        hidden: true
    },
    {
        path: '/datav/pm',
        component: () => import('@/views/dataview/pm'),
        leaf: false,
        hidden: true
    },
    {
        path: '/datav/project',
        component: () => import('@/views/dataview/project-index'),
        leaf: false,
        hidden: true
    },
    {
        path: '/datav/customer',
        component: () => import('@/views/dataview/customer'),
        leaf: false,
        hidden: true
    },
    {
        path: '/datavIndex',
        component: () => import('@/views/dataview/index'),
        leaf: false,
        hidden: true
    },
    {
        path: '/bizCompasition',
        component: () => import('@/views/dataview/bizCompasition'),
        leaf: false,
        hidden: true
    },
    {
        path: '/datav/biz',
        component: () => import('@/views/datav/biz'),
        leaf: false,
        hidden: true
    },
    {
        path: '/forgotPassword',
        component: () => import('@/views/ForgotPassword'),
        leaf: false,
        hidden: true
    },
    {
        path: '/',
        component: HomeView,
        name: '首页',
        redirect:'/home/welcomeView',
        children:[
            {
                component: Navigation,
                path:"/home",
                name:"工作视窗",
                children:[
                    {               
                        component: welcomeView,
                        path:"/home/welcomeView",
                        hidden:true,
                        name:"工作台",
                    },
                ]
            }
        ]
    },
];


export default routes;


// WEBPACK FOOTER //
// ./src/routes.js